import Web3 from 'web3'

export const DEFAULT_NETWORK = parseInt(process.env.REACT_APP_DEFAULT_CHAINID ??'3') 
export const mainnetRPC = 'https://mainnet.infura.io/v3/'
export const ropstenRPC = 'https://ropsten.infura.io/v3/'
export const defaultRPC = new Web3.providers.HttpProvider(DEFAULT_NETWORK === 1 ? mainnetRPC : ropstenRPC)
